import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editCover, setConfirmDeleteMember } from '@om/redux/actions/easiplusFuneralPlan/quote';
import { OmLabeledValueSummary, OmEfpFamilyMemberCard } from '@om/component-library-react';
import { getActivePageIndex, getContinueButtonText } from '@om/redux/selectors/kaMetlhaFuneralCover/routing';
import { createStructuredSelector } from 'reselect';

const KmfFamilyMemberCard = ({
    id,
    relationship,
    age,
    coverAmount,
    name,
    monthlyPremium,
    category,
    onDelete,
    deleteEnabled = false,
    onEdit,
    editEnabled = true
}) => {
    const dispatch = useDispatch();

    const {
        activePageIndex,
    } = useSelector(
        createStructuredSelector({
            activePageIndex: getActivePageIndex,
        })
    );
    const getValueWithThousandSeperator=(amount)=>{
        let decimalSeperate = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return decimalSeperate
    }
    return (
        <OmEfpFamilyMemberCard
            expanded
            editEnabled={editEnabled}
            deleteEnabled={deleteEnabled}
            addDetailsEnabled
            cardId={id}
            onEditDetailsClicked={onEdit}
            onPopupModal={onDelete}
        >
            <h6 className="strong small no-top-margin no-bottom-margin" slot="family-member-card-heading">
                {relationship}
            </h6>
            <div style={{display:'flex',gap:'10px', padding:'0 0 0 20px', justifyContent:'space-between', width:'calc(100% - 20px)'}} slot="family-member-card-body">
                {activePageIndex == 2 ? (<OmLabeledValueSummary label="Name" value={name} />) : ''}
                <OmLabeledValueSummary label="AGE" value={age} />
                <OmLabeledValueSummary label="COVER AMOUNT" value={'P' + getValueWithThousandSeperator(coverAmount)} />
                <OmLabeledValueSummary label="MONTHLY PREMIUM" value={monthlyPremium ? ('P' + monthlyPremium?.toFixed(2)) : '-'} />
            </div>
        </OmEfpFamilyMemberCard>
    );
};

export default KmfFamilyMemberCard;
